/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__table_head_iti_details = /** @type {(inputs: {}) => string} */ () => {
	return `Details der Route (Start, Ziel, Zwischenziele)`
};

const en_bookmark__table_head_iti_details = /** @type {(inputs: {}) => string} */ () => {
	return `Route details (start, finish, stages)`
};

const es_bookmark__table_head_iti_details = /** @type {(inputs: {}) => string} */ () => {
	return `Detalles de la ruta (salida, llegada, etapas)`
};

const fr_bookmark__table_head_iti_details = /** @type {(inputs: {}) => string} */ () => {
	return `Détails de l'itinéraire (départ, arrivée, étapes)`
};

const it_bookmark__table_head_iti_details = /** @type {(inputs: {}) => string} */ () => {
	return `Dettagli del percorso (partenza, arrivo, tappe)`
};

const nl_bookmark__table_head_iti_details = /** @type {(inputs: {}) => string} */ () => {
	return `Routegegevens (start, finish, etappes)`
};

const pt_bookmark__table_head_iti_details = /** @type {(inputs: {}) => string} */ () => {
	return `Detalhes do itinerário (início, fim, etapas)`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__table_head_iti_details = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__table_head_iti_details(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__table_head_iti_details", locale)
	if (locale === "de") return de_bookmark__table_head_iti_details(inputs)
	if (locale === "en") return en_bookmark__table_head_iti_details(inputs)
	if (locale === "es") return es_bookmark__table_head_iti_details(inputs)
	if (locale === "fr") return fr_bookmark__table_head_iti_details(inputs)
	if (locale === "it") return it_bookmark__table_head_iti_details(inputs)
	if (locale === "nl") return nl_bookmark__table_head_iti_details(inputs)
	return pt_bookmark__table_head_iti_details(inputs)
};